import { Trans } from '@lingui/macro';
import { TireInQuoteItem, TireOfferV2 } from 'noddi-types';

import { NoddiIcon } from 'noddi-ui-common';
import { formatCurrencyAmount, getTirePrice } from 'noddi-util';

interface TireOfferPaymentSummaryProps {
  quoteItemTires: TireInQuoteItem[];
  genericItems: TireOfferV2['genericItems'];
}

export const TireOfferPaymentSummary = ({ quoteItemTires, genericItems }: TireOfferPaymentSummaryProps) => {
  const totalTireSum = quoteItemTires.reduce((sum, tire) => {
    const price = getTirePrice(tire);
    return sum + price.amount * (tire.quantitySelected ?? 0);
  }, 0);

  const totalSum = genericItems.reduce((acc, item) => acc + item.price.amount, 0) + totalTireSum;

  return (
    <div className='flex flex-col gap-2'>
      {quoteItemTires.map((tire) => {
        const price = getTirePrice(tire);
        return (
          <div key={tire.id}>
            <div className='flex justify-between gap-4'>
              <div className='-ml-1 flex gap-1'>
                <NoddiIcon name='WheelAngle' />
                <p className='font-bold'>
                  {tire.tireInventory.tire.brand.name} - {tire.tireInventory.tire.model}
                </p>
              </div>
              <p>
                {formatCurrencyAmount({
                  money: { amount: price.amount * (tire.quantitySelected ?? 0), currency: price.currency }
                })}
              </p>
            </div>
            <div className='mb-2 flex justify-end'>
              <p className='text-black/70'>
                {tire.quantitySelected ?? 0} <Trans>pcs</Trans>
              </p>
            </div>
          </div>
        );
      })}

      {genericItems.map(({ name, price, id }) => (
        <div className='flex justify-between gap-4' key={id}>
          <p>{name}</p>
          <p>
            {formatCurrencyAmount({
              money: { amount: price.amount, currency: price.currency }
            })}
          </p>
        </div>
      ))}

      <div className='border-t'>
        <div className='mt-2 flex justify-between gap-2'>
          <p>
            <Trans>Total sum including VAT</Trans>
          </p>
          <p>
            {formatCurrencyAmount({
              money: { amount: totalSum }
            })}
          </p>
        </div>
      </div>
    </div>
  );
};
